import {
  createContext,
  useCallback,
  useContext,
  useState,
  type ReactNode,
} from "react"

interface GeneratorContextValue {
  worksheetName: string
  setWorksheetName: (name: string) => void
}

const GeneratorContext = createContext<GeneratorContextValue | null>(null)

export const useGeneratorContext = () => {
  const context = useContext(GeneratorContext)
  if (!context) {
    throw new Error(
      "useGeneratorContext must be used within a GeneratorProvider",
    )
  }
  return context
}

interface GeneratorProviderProps {
  children: ReactNode
  defaultName: string
}

export const GeneratorProvider: React.FC<GeneratorProviderProps> = ({
  children,
  defaultName,
}) => {
  const [worksheetName, setWorksheetNameState] = useState(defaultName)

  const setWorksheetName = useCallback((name: string) => {
    setWorksheetNameState(name)
  }, [])

  return (
    <GeneratorContext.Provider value={{ worksheetName, setWorksheetName }}>
      {children}
    </GeneratorContext.Provider>
  )
}
